import { DownLoadClientListActionTypes } from "../constants/ApiConstants";

const initialState = {
    loading: false,
    masterData: [],
    patientsList: [],
}

export default (state = initialState, { type, payload }) => {
    switch (type) {
        case DownLoadClientListActionTypes.get_masterData.REQUEST:
            return {
                ...state,
                loading: true,
                masterData: null,
            };
        case DownLoadClientListActionTypes.get_masterData.SUCCESS:
            return {
                ...state,
                loading: false,
                masterData: payload,
            };
        case DownLoadClientListActionTypes.downloadClientList.REQUEST:
            return {
                ...state,
                loading: true,
               
            };
        case DownLoadClientListActionTypes.downloadClientList.SUCCESS:
            return {
                ...state,
                loading: false,
            };
        case DownLoadClientListActionTypes.get_clientBehaviourListDownload.REQUEST:
            return {
                ...state,
                loading: true,
               
            };
        case DownLoadClientListActionTypes.get_clientBehaviourListDownload.SUCCESS:
            return {
                ...state,
                loading: false,
            };
        case DownLoadClientListActionTypes.get_DomainsList.REQUEST:
            return {
                ...state,
                loading: true,
                domainList: null
            };
        case DownLoadClientListActionTypes.get_DomainsList.SUCCESS:
            return {
                ...state,
                loading: false,
                domainList: payload,
            };
        case DownLoadClientListActionTypes.get_ProgramList.REQUEST:
            return {
                ...state,
                loading: true,
                programList: null
            };
        case DownLoadClientListActionTypes.get_ProgramList.SUCCESS:
            return {
                ...state,
                loading: false,
                programList: payload,
            };  
        case DownLoadClientListActionTypes.get_PatientsList.REQUEST:
            return {
                ...state,
                patientsList:payload
            }      
        case DownLoadClientListActionTypes.get_PatientsList.SUCCESS:
            return {
                ...state,
                patientsList:payload
            }
        default:
            return state

    }
}


// WEBPACK FOOTER //
// ./src/modules/MastersDataCollection/settings/uploadExcel/downLoadClientList/reducers/dowloadClientlistReducer.js